module.exports = __webpack_public_path__ + "assets/02db5ad2af9465c2f2fe36275b2e770a.svg";